import React, { useEffect, useState, Fragment } from 'react';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import { TableContentUserList } from '../../Common/Table/tableContent';

export const PackageCreationListing = ({ packageCreationData, handleClick, handleReset }) => {

    const [packageCreation, setPackageCreation] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    
    const contentRowNames = ["collectionPointName", "cardNumber", "userName", "packageCode", "packageName", "vehicleRegistrationNumber", "isActive"]

    useEffect(() => {
        trackPromise(
            setPackageCreationData()
        )
        
        return () => {
            destroyDataTable();
        };
    }, [packageCreationData]);

    useEffect(() => {
        if (packageCreation.length > 0) {
            createDataTable();
            setIsTableHide(false);
        }
    }, [packageCreation]);

    async function setPackageCreationData() {
        setIsTableHide(true);
        destroyDataTable();
        await setPackageCreation(packageCreationData);
        
    }

    function destroyDataTable() {
        if ($.fn.DataTable.isDataTable('#example')) {
            $('#example').DataTable().destroy();
        }
    }

    function createDataTable() {
        $('#example').DataTable({
            language: {
                emptyTable: 'No records found',
                zeroRecords: 'No records found'
            }
        });
    }

    const content = (da) => contentRowNames.map((row, index) => {
        return (
            (row === "isActive" ? (da[row] === true ? <td key={index}>Active</td> : <td key={index}>Inactive</td>) :
                <td key={index}>{da[row] + " "}</td>
            )
        )
    });

    return (
            <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="table-responsive row-top-gap" hidden={isTableHide}>
                            <table id="example" className="display dataTable no-footer" >
                               
                                <thead>
                                    <tr>
                                        <th>Collection Point</th>
                                        <th>Card Number</th>
                                        <th>User Name</th>
                                        <th>Package Code</th>
                                        <th>Package Name</th>
                                        <th>Vehicle Name</th>
                                        <th>Status</th>
                                        <th>Actions</th>
                                        <th>Password Reset</th>
                                    </tr>
                                </thead>                        
                                <tbody>
                                    <TableContentUserList
                                        data={packageCreation}
                                        contentRowNames={contentRowNames}
                                        handleClick={handleClick}
                                        handleReset={handleReset}
                                    />

                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment> 
    )

}